export default "__VITE_ASSET__h47BDviU__"